import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useFirestore } from '../contexts/FirestoreContext';
import SiteUpload from '../components/onboarding/SiteUpload';
import StaffUpload from '../components/onboarding/StaffUpload';
import BulkSMSPanel from '../components/admin/BulkSMSPanel';
// Removed redundant CMT Hierarchy feature
import CMTStructureTab from '../components/admin/CMTStructureTab';

import { UserIcon, ShieldIcon, FileTextIcon, BellIcon, KeyIcon } from '../icons';
import { SettingOutlined, BankOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { where, collection, query, getDocs, orderBy, addDoc, getDoc, doc, updateDoc, setDoc, deleteDoc, writeBatch } from 'firebase/firestore';
import { getAuth, EmailAuthProvider, reauthenticateWithCredential, updatePassword, sendPasswordResetEmail, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { ROLE_PERMISSIONS, formatRoleDisplay, getRoleColor } from '../models/role';
import PageHeader from '../components/PageHeader';
import UserProfile from '../components/UserProfile';
import { useNavigate } from 'react-router-dom';
import { message, Modal, Space, Input, Tabs, Table, Card, Switch, Typography, Tag, Button, Select, Form, Tooltip, InputNumber, Checkbox, Row, Col, Upload, List } from 'antd';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../config/firebase';
import ClientOrgManagement from '../components/admin/ClientOrgManagement';
import { demoOrgData } from '../data/demoOrgData';
import { updateTestOrg } from '../utils/updateTestOrg';
import { ExclamationCircleOutlined, CheckCircleOutlined, MinusCircleOutlined, PlusOutlined, InboxOutlined, ReloadOutlined, DeleteOutlined } from '@ant-design/icons';
import { getAllAccessibleCmts } from '../utils/cmtUtils';
import OnboardingWizard from '../pages/OnboardingWizard';
import { getActivityTypeLabel } from '../utils/activityLogger';
import { OBLIGATION_CATEGORIES, REGULATORY_BODIES, PREDEFINED_OBLIGATIONS } from '../models/regulatoryObligations';
import { DIGITAL_PRODUCTS } from '../models/digitalProducts';
import setupOrganisationProducts from '../utils/setupOrganisationProducts';
import { fixUserData } from '../utils/fixUserData';

import CMTAdminInterface from '../components/admin/CMTAdminInterface';
import EnhancedUsersTab from '../components/admin/EnhancedUsersTab';
import EnhancedUsersTabV2 from '../components/admin/EnhancedUsersTabV2';
import cmtService from '../services/cmtService';


const { Title, Text } = Typography;

const SUBSCRIPTION_PLANS = [
  { value: 'business-pro', label: 'Business Pro' },
  { value: 'enterprise-pro', label: 'Enterprise Pro' }
];

const INDUSTRY_SECTORS = [
  'Education',
  'Energy',
  'Financial Services',
  'Government',
  'Healthcare',
  'Manufacturing',
  'Non-Profit',
  'Other',
  'Retail',
  'Technology',
  'Transportation'
];

const TIMEZONES = [
  'Australia/Sydney',
  'Australia/Melbourne',
  'Australia/Brisbane',
  'Australia/Perth',
  'Australia/Adelaide',
  'Australia/Darwin',
  'Australia/Hobart',
  'Pacific/Auckland',
  'Asia/Singapore',
  'Asia/Tokyo',
  'America/New_York',
  'Europe/London'
];

const CMT_ROLES = [
  'Leader',
  'Alternate',
  'Comms/Media',
  'Security',
  'IT',
  'HR',
  'Legal',
  'Finance',
  'Operations',
  'Other'
];

const NOTIFICATION_METHODS = [
  'Email',
  'Web Portal',
  'SMS',
  'Phone Call',
  'Letter',
  'Other'
];

const TIME_UNITS = [
  { label: 'Minutes', value: 'minutes' },
  { label: 'Hours', value: 'hours' },
  { label: 'Days', value: 'days' }
];

export default function Admin() {
  const { currentUser, logout } = useAuth();
  const { db, getDocuments } = useFirestore();
  const [activeTab, setActiveTab] = useState('clients');
  const [usersTabRefreshTick, setUsersTabRefreshTick] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [users, setUsers] = useState([]);
  const [logs, setLogs] = useState([]);
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [isDeactivateModalVisible, setIsDeactivateModalVisible] = useState(false);
  const [orgToDeactivate, setOrgToDeactivate] = useState(null);
  const [deactivateConfirmText, setDeactivateConfirmText] = useState('');
  const [isReactivateModalVisible, setIsReactivateModalVisible] = useState(false);
  const [orgToReactivate, setOrgToReactivate] = useState(null);
  const [reactivateConfirmText, setReactivateConfirmText] = useState('');
  const [isDeactivateUserModalVisible, setIsDeactivateUserModalVisible] = useState(false);
  const [userToDeactivate, setUserToDeactivate] = useState(null);
  const [deactivateUserConfirmText, setDeactivateUserConfirmText] = useState('');
  const navigate = useNavigate();
  const [viewEditModalVisible, setViewEditModalVisible] = useState(false);
  const [viewEditMode, setViewEditMode] = useState('view'); // 'view' or 'edit'
  const [modalOrg, setModalOrg] = useState(null);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [detailedViewMode, setDetailedViewMode] = useState(null); // null, 'view', or 'edit'
  const [selectedOrgForDetail, setSelectedOrgForDetail] = useState(null);
  const [selectedOrgUsers, setSelectedOrgUsers] = useState([]);
  const [selectedOrgUsersLoading, setSelectedOrgUsersLoading] = useState(false);
  const functions = getFunctions(app, 'australia-southeast2');
  const [isDeepDeleteModalVisible, setIsDeepDeleteModalVisible] = useState(false);
  const [deepDeleteTargetOrg, setDeepDeleteTargetOrg] = useState(null);
  const [deepDeleteConfirmText, setDeepDeleteConfirmText] = useState('');
  const [deleteAuthExclusive, setDeleteAuthExclusive] = useState(true);
  
  
  // Test Organization Deletion States
  const [isDeleteTestOrgModalVisible, setIsDeleteTestOrgModalVisible] = useState(false);

  const [addDigitalProductModalVisible, setAddDigitalProductModalVisible] = useState(false);

  const [orgToDelete, setOrgToDelete] = useState(null);
  const [deleteConfirmText, setDeleteConfirmText] = useState('');

  const loadUsers = useCallback(async () => {
    try {
      setLoading(true);
      console.log('currentUser in Admin.jsx:', currentUser);
      console.log('currentUser.orgId:', currentUser?.orgId);
      
      if (!currentUser?.orgId) {
        console.error('No orgId found in currentUser');
        setError('User organisation not found. Please log out and log back in.');
        return;
      }

      const q = query(
        collection(db, 'c3_users'),
        where('orgId', '==', currentUser.orgId)
      );
      console.log('Query:', q);
      
      const querySnapshot = await getDocs(q);
      console.log('Query snapshot:', querySnapshot);
      
      const userList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      console.log('Processed userList:', userList);
      
      setUsers(userList);
    } catch (err) {
      console.error('Error loading users:', err);
      setError('Failed to load users: ' + (err.message || err.code || 'unknown error'));
    } finally {
      setLoading(false);
    }
  }, [currentUser?.orgId, db]);

  const loadLogs = useCallback(async () => {
    try {
      setLoading(true);
      let logsQuery;

      if (currentUser?.role === 'developer' || currentUser?.isAdmin) {
        // Super admins can see all logs
        logsQuery = query(
          collection(db, 'c3_auditLogs'),
          orderBy('timestamp', 'desc')
        );
      } else {
        // Get all CMTs the user has access to
        const accessibleCmts = await getAllAccessibleCmts(currentUser.uid);
        
        // Query logs for the user's organization and accessible CMTs
        logsQuery = query(
          collection(db, 'c3_auditLogs'),
          where('orgId', '==', currentUser.orgId),
          where('cmtId', 'in', accessibleCmts),
          orderBy('timestamp', 'desc')
        );
      }

      const querySnapshot = await getDocs(logsQuery);
      const logs = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setLogs(logs);
    } catch (error) {
      console.error('Error loading logs:', error);
      message.error('Failed to load logs');
    } finally {
      setLoading(false);
    }
  }, [currentUser]);

  const loadOrganisations = useCallback(async (forceRefresh = false) => {
    try {
      setLoading(true);
              console.log('Loading organisations...', { forceRefresh });
      const orgsRef = collection(db, 'c3_organisations');
      
      // Force a fresh query by adding a timestamp
      const q = forceRefresh 
        ? query(orgsRef, where('_refreshTimestamp', '>=', 0))
        : orgsRef;

      const orgsSnapshot = await getDocs(q);
              console.log('Raw organisations snapshot:', orgsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })));
      
      const orgsList = orgsSnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          ...data,
          clientStatus: data.clientStatus || 'active',
          createdAt: data.createdAt || new Date(),
          name: data.name || 'Unnamed Organisation'
        };
      });
      
              console.log('Setting organisations list:', orgsList);
      setOrganisations(orgsList);
      setError('');
    } catch (err) {
      console.error('Error loading organisations:', err);
      setError('Failed to load organisations');
    } finally {
      setLoading(false);
    }
  }, [db]);

      // Load organisations when component mounts or when clients tab becomes active
  useEffect(() => {
    console.log('Admin component mounted or tab changed:', { activeTab });
    if (activeTab === 'clients') {
      console.log('Loading organisations for clients tab...');
      loadOrganisations(true);
    }
  }, [activeTab, loadOrganisations]);

  // Force refresh organisations when navigating to admin page
  useEffect(() => {
    console.log('Checking navigation state...');
    const location = window.location;
    const searchParams = new URLSearchParams(location.search);
    const state = location.state || {};
    
    console.log('Navigation state:', { 
      searchParams: searchParams.toString(),
      state,
      activeTab
    });

    if (state.activeTab === 'clients' || searchParams.get('tab') === 'clients') {
      console.log('Forcing refresh of organisations list...');
      setActiveTab('clients');
      loadOrganisations(true);
    }
  }, [loadOrganisations]);

  useEffect(() => {
    if (activeTab === 'users') {
      loadUsers();
    } else if (activeTab === 'logs') {
      loadLogs();
    } else if (activeTab === 'clients') {
      console.log('Loading organisations for clients tab...');
      loadOrganisations();
    }
  }, [activeTab, loadUsers, loadLogs, loadOrganisations]);

  useEffect(() => {
    console.log('Current User Data:', {
      uid: currentUser?.uid,
      email: currentUser?.email,
      orgId: currentUser?.orgId,
      role: currentUser?.role,
      tier: currentUser?.tier,
      isAdmin: currentUser?.isAdmin
    });
  }, [currentUser]);

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = e.target;
    
    if (newPassword.value !== confirmPassword.value) {
      setError('New passwords do not match');
      return;
    }

    try {
      setLoading(true);
      const auth = getAuth();
      // Reauthenticate user
      const credential = EmailAuthProvider.credential(
        currentUser.email,
        currentPassword.value
      );
      await reauthenticateWithCredential(currentUser, credential);
      
      // Update password
      await updatePassword(currentUser, newPassword.value);
      
      // Log the password change
      await addDoc(collection(db, 'c3_auditLogs'), {
        type: 'password_change',
        userId: currentUser.uid,
        orgId: currentUser.orgId,
        timestamp: new Date(),
        details: 'Password changed successfully'
      });

      alert('Password updated successfully');
      e.target.reset();
    } catch (err) {
      console.error('Error changing password:', err);
      setError('Failed to change password. Please check your current password.');
    } finally {
      setLoading(false);
    }
  };

  const handleStartOnboarding = () => {
    navigate('/onboarding');
  };

  const handleViewOrgConfig = (org) => {
    console.log('Viewing config for org:', org);
    setSelectedOrgForDetail(org);
    setDetailedViewMode('view');
  };

  const handleUpdateTestOrg = async () => {
    try {
      setLoading(true);
      await updateTestOrg();
      message.success('Test organization updated successfully');
      loadOrganisations();
    } catch (error) {
      console.error('Error updating test organization:', error);
      message.error('Failed to update test organization');
    } finally {
      setLoading(false);
    }
  };

  const handleFixUserData = async () => {
    try {
      setLoading(true);
      const result = await fixUserData();
      message.success(`User data fixed! Processed ${result.processed} users, updated ${result.updated} users.`);
      // Refresh the current organization's users if we're viewing one
      if (selectedOrgForDetail) {
        fetchSelectedOrgUsers(selectedOrgForDetail.id);
      }
    } catch (error) {
      console.error('Error fixing user data:', error);
      message.error('Failed to fix user data');
    } finally {
      setLoading(false);
    }
  };

  const handleDeactivateClick = (org) => {
    setOrgToDeactivate(org);
    setIsDeactivateModalVisible(true);
  };

  const handleDeactivateConfirm = async () => {
    if (deactivateConfirmText !== 'YES') {
      message.error('Please type YES to confirm');
      return;
    }

    try {
      setLoading(true);
      await updateDoc(doc(db, 'c3_organisations', orgToDeactivate.id), {
        clientStatus: 'inactive',
        deactivatedAt: new Date(),
        deactivatedBy: currentUser.uid
      });

              message.success('Organisation deactivated successfully');
      setIsDeactivateModalVisible(false);
      setDeactivateConfirmText('');
      setOrgToDeactivate(null);
      loadOrganisations();
    } catch (error) {
      console.error('Error deactivating organization:', error);
      message.error('Failed to deactivate organization');
    } finally {
      setLoading(false);
    }
  };

  const handleDeactivateCancel = () => {
    setIsDeactivateModalVisible(false);
    setDeactivateConfirmText('');
    setOrgToDeactivate(null);
  };

  const handleReactivateClick = (org) => {
    setOrgToReactivate(org);
    setIsReactivateModalVisible(true);
  };

  const handleReactivateConfirm = async () => {
    if (reactivateConfirmText !== 'YES') {
      message.error('Please type "YES" to confirm reactivation');
      return;
    }

    try {
      await updateDoc(doc(db, 'c3_organisations', orgToReactivate.id), {
        clientStatus: 'active',
        reactivatedAt: new Date(),
        reactivatedBy: currentUser.uid,
        updatedAt: new Date(),
        updatedBy: currentUser.uid
      });

              message.success('Organisation reactivated successfully');
      setIsReactivateModalVisible(false);
      setReactivateConfirmText('');
      setOrgToReactivate(null);
      loadOrganisations();
    } catch (err) {
      console.error('Error reactivating organization:', err);
      message.error('Failed to reactivate organization');
    }
  };

  const handleReactivateCancel = () => {
    setIsReactivateModalVisible(false);
    setReactivateConfirmText('');
    setOrgToReactivate(null);
  };

  const handleDeactivateUserClick = (user) => {
    setUserToDeactivate(user);
    setIsDeactivateUserModalVisible(true);
  };

  const handleDeactivateUserConfirm = async () => {
    if (deactivateUserConfirmText !== userToDeactivate?.email) {
      message.error('Please type the user\'s email address to confirm deactivation');
      return;
    }

    try {
      // Soft delete: Mark user as inactive
      await updateDoc(doc(db, 'c3_users', userToDeactivate.id), {
        status: 'inactive',
        deactivatedAt: new Date(),
        deactivatedBy: currentUser.uid,
        deactivationReason: 'Deactivated by Super Admin',
        updatedAt: new Date(),
        updatedBy: currentUser.uid
      });

      message.success('User deactivated successfully');
      
      // Refresh the users list
      await fetchSelectedOrgUsers(selectedOrgForDetail.id);
      
      // Close modal and reset state
      handleDeactivateUserCancel();

    } catch (error) {
      console.error('Error deactivating user:', error);
      message.error('Failed to deactivate user');
    }
  };

  const handleDeactivateUserCancel = () => {
    setIsDeactivateUserModalVisible(false);
    setDeactivateUserConfirmText('');
    setUserToDeactivate(null);
  };

  // Test Organization Deletion Handlers
  const handleDeleteTestOrgClick = (org) => {
    setOrgToDelete(org);
    setIsDeleteTestOrgModalVisible(true);
  };

  const handleDeleteTestOrgConfirm = async () => {
    if (deleteConfirmText !== orgToDelete?.name) {
      message.error('Please type the organization name exactly to confirm deletion');
      return;
    }

    // Safety check: Only allow deletion of test organizations
    if (!orgToDelete.isTestOrganization) {
      message.error('Only test organizations can be permanently deleted');
      return;
    }

    try {
      setLoading(true);
      
      // Simple cascade deletion for test organizations
      const batch = writeBatch(db);
      
      // Delete subcollections (cmts, incidents, tasks, etc.)
      const subcollections = ['cmts', 'incidents', 'tasks', 'crisis_plans', 'notifications'];
      
      for (const subcol of subcollections) {
        try {
          const subRef = collection(db, 'c3_organisations', orgToDelete.id, subcol);
          const subSnapshot = await getDocs(subRef);
          subSnapshot.docs.forEach(subDoc => {
            batch.delete(subDoc.ref);
          });
        } catch (error) {
          console.log(`No ${subcol} subcollection found or error deleting:`, error);
        }
      }
      
      // Delete associated users (only if they appear to be test users)
      try {
        const usersRef = collection(db, 'c3_users');
        const usersQuery = query(usersRef, where('orgId', '==', orgToDelete.id));
        const usersSnapshot = await getDocs(usersQuery);
        
        usersSnapshot.docs.forEach(userDoc => {
          const userData = userDoc.data();
          // Only delete users that appear to be test users
          if (userData.email?.includes('test') || 
              userData.email?.includes('demo') || 
              userData.email?.includes('trial') ||
              userData.isTestUser === true) {
            batch.delete(userDoc.ref);
          }
        });
      } catch (error) {
        console.log('No users found or error deleting users:', error);
      }
      
      // Delete main organization document
      batch.delete(doc(db, 'c3_organisations', orgToDelete.id));
      
      // Add audit log entry
      const auditLogRef = doc(collection(db, 'c3_audit_logs'));
      batch.set(auditLogRef, {
        action: 'PERMANENT_DELETE_TEST_ORG',
        orgId: orgToDelete.id,
        orgName: orgToDelete.name,
        deletedBy: currentUser.uid,
        deletedAt: new Date(),
        reason: 'Test organization cleanup',
        details: `Permanently deleted test organization: ${orgToDelete.name}`
      });
      
      // Commit all deletions
      await batch.commit();
      
      message.success(`Test organization "${orgToDelete.name}" has been permanently deleted`);
      
      // Close modal and refresh organization list
      handleDeleteTestOrgCancel();
      loadOrganisations();
      
    } catch (error) {
      console.error('Error deleting test organization:', error);
      message.error('Failed to delete test organization');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTestOrgCancel = () => {
    setIsDeleteTestOrgModalVisible(false);
    setDeleteConfirmText('');
    setOrgToDelete(null);
  };

  const handleEditOrg = (org) => {
    console.log('Editing org:', org);
    setSelectedOrgForDetail(org);
    setDetailedViewMode('edit');
  };

  const handleOpenDeepDelete = (org) => {
    const target = org || selectedOrgForDetail;
    if (!target) {
      message.error('No organization selected');
      return;
    }
    console.log('Deep delete clicked for org:', target.id);
    setDeepDeleteTargetOrg(target);
    setDeleteAuthExclusive(true);
    setDeepDeleteConfirmText('');
    setIsDeepDeleteModalVisible(true);
  };

  const handleConfirmDeepDelete = async () => {
    try {
      if (!deepDeleteTargetOrg) {
        message.error('No organization selected');
        return;
      }
      if (deepDeleteConfirmText !== deepDeleteTargetOrg.name) {
        message.warning('Confirmation text does not match org name.');
        return;
      }
      setLoading(true);
      const callable = httpsCallable(functions, 'deepDeleteOrg');
      const res = await callable({ orgId: deepDeleteTargetOrg.id, deleteAuthExclusive, skipGrace: true });
      console.log('deepDeleteOrg result:', res.data);
      message.success(`Deep deleted org: ${deepDeleteTargetOrg.name}`);
      setIsDeepDeleteModalVisible(false);
      setDeepDeleteTargetOrg(null);
      await loadOrganisations();
      setSelectedOrgForDetail(null);
      setDetailedViewMode(null);
    } catch (err) {
      console.error('deepDeleteOrg failed', err);
      message.error(`Deep delete failed: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelDeepDelete = () => {
    setIsDeepDeleteModalVisible(false);
    setDeepDeleteTargetOrg(null);
    setDeepDeleteConfirmText('');
  };

  const handleEditUser = (user) => {
    // TODO: Implement user editing functionality
    message.info('User editing functionality coming soon');
  };

  const handleDeactivateUser = async (user) => {
    try {
      setLoading(true);
      await updateDoc(doc(db, 'c3_users', user.id), {
        status: 'inactive',
        deactivatedAt: new Date(),
        deactivatedBy: currentUser.uid
      });

      message.success('User deactivated successfully');
      loadUsers(); // Refresh the users list
    } catch (error) {
      console.error('Error deactivating user:', error);
      message.error('Failed to deactivate user');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadLogs = async () => {
    try {
      const csvContent = [
        ['Timestamp', 'Type', 'User', 'Incident', 'Details'],
        ...logs.map(log => [
          log.timestamp?.toDate ? log.timestamp.toDate().toLocaleString() : new Date(log.timestamp).toLocaleString(),
          log.type,
          users.find(u => u.id === log.userId)?.email || log.userId,
          log.incidentId || 'N/A',
          log.details
        ])
      ].map(row => row.join(',')).join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `activity-logs-${new Date().toISOString().split('T')[0]}.csv`;
      link.click();
    } catch (err) {
      console.error('Error downloading logs:', err);
      setError('Failed to download logs');
    }
  };

  const handlePrintLogs = () => {
    const printWindow = window.open('', '_blank');
    const content = `
      <html>
        <head>
          <title>Activity Logs</title>
          <style>
            table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f5f5f5; }
            h1 { text-align: center; }
            @media print {
              body { margin: 20px; }
            }
          </style>
        </head>
        <body>
          <h1>Activity Logs</h1>
          <table>
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Type</th>
                <th>User</th>
                <th>Incident</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              ${logs.map(log => `
                <tr>
                  <td>${log.timestamp?.toDate ? log.timestamp.toDate().toLocaleString() : new Date(log.timestamp).toLocaleString()}</td>
                  <td>${getActivityTypeLabel(log.type)}</td>
                  <td>${log.userEmail || users.find(u => u.id === log.userId)?.email || log.userId}</td>
                  <td>${log.incidentId || 'N/A'}</td>
                  <td>${log.details}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;
    printWindow.document.write(content);
    printWindow.document.close();
    printWindow.print();
  };

  const fetchSelectedOrgUsers = async (organizationId) => {
    if (!organizationId) return;
    
    try {
      setSelectedOrgUsersLoading(true);
      
      // Fetch users from c3_users collection
      const usersRef = collection(db, 'c3_users');
      const usersQuery = query(
        usersRef,
        where('orgId', '==', organizationId)
      );
      
      const usersSnapshot = await getDocs(usersQuery);
      const existingUsers = usersSnapshot.docs
        .map(doc => {
          const userData = doc.data();
          console.log('=== EXISTING USER DATA ===');
          console.log('User ID:', doc.id);
          console.log('Email:', userData.email);
          console.log('Full Name:', userData.fullName);
          console.log('Role:', userData.role);
          console.log('CMT Role:', userData.cmtRole);
          console.log('Status:', userData.status);
          return {
            id: doc.id,
            source: 'c3_users',
            ...userData
          };
        })
        .filter(user => user.status !== 'inactive'); // Filter out inactive users
      
      // Fetch organization document to get CMT members
      const orgRef = doc(db, 'c3_organisations', organizationId);
      const orgSnapshot = await getDoc(orgRef);
      // Legacy fallback only; primary source is multiCmtMembers
      let cmtMembers = [];
      
      if (orgSnapshot.exists()) {
        const orgData = orgSnapshot.data();
        // Centralized flatten (monitored) from service
        const flattened = cmtService.flattenMembersFromOrgDoc(orgData);
        if (flattened.length > 0) {
          cmtMembers = flattened.map((member, index) => ({
            id: `cmt-${index}-${member.email}`,
            source: 'cmt_members',
            email: member.email,
            fullName: member.fullName,
            firstName: member.fullName?.split(' ')[0] || '',
            lastName: member.fullName?.split(' ').slice(1).join(' ') || '',
            phone: member.phone,
            cmtRole: member.cmtRole,
            role: 'other',
            hasBackup: member.hasBackup,
            backupName: member.backupName,
            backupPhone: member.backupPhone,
            lastLogin: null,
            cmtId: member.cmtId || 'default_cmt'
          }));
        } else {
          cmtMembers = (orgData.cmtMembers || []).map((member, index) => {
          console.log('=== CMT MEMBER DATA ===');
          console.log('Member:', member);
          return {
            id: `cmt-${index}-${member.email}`, // Create a unique ID for CMT members
            source: 'cmt_members',
            email: member.email,
            fullName: member.fullName,
            firstName: member.fullName?.split(' ')[0] || '',
            lastName: member.fullName?.split(' ').slice(1).join(' ') || '',
            phone: member.phone,
            cmtRole: member.cmtRole,
            role: 'other', // Default role for CMT members without specific role
            hasBackup: member.hasBackup,
            backupName: member.backupName,
            backupPhone: member.backupPhone,
            lastLogin: null // CMT members from org data won't have login info
          };
        });
        }
      }
      
      // Combine both lists, avoiding duplicates (prefer c3_users data over CMT data for existing users)
      const existingUserEmails = new Set(existingUsers.map(user => user.email));
      const uniqueCmtMembers = cmtMembers.filter(member => !existingUserEmails.has(member.email));
      
      const allUsers = [...existingUsers, ...uniqueCmtMembers];
      
      // Sort by name
      allUsers.sort((a, b) => {
        const nameA = a.fullName || a.firstName || a.email || '';
        const nameB = b.fullName || b.firstName || b.email || '';
        return nameA.localeCompare(nameB);
      });
      
      console.log('=== COMBINED USER LIST ===');
      console.log('Existing users:', existingUsers.length);
      console.log('Unique CMT members:', uniqueCmtMembers.length);
      console.log('Total users:', allUsers.length);
      console.log('All users:', allUsers);
      
      setSelectedOrgUsers(allUsers);
    } catch (error) {
      console.error('Error fetching organization users:', error);
      setSelectedOrgUsers([]);
    } finally {
      setSelectedOrgUsersLoading(false);
    }
  };

  const handleViewOrg = (org) => {
    setSelectedOrgForDetail(org);
    setDetailedViewMode('view');
    fetchSelectedOrgUsers(org.id);
  };

  const handleEditOrgModal = (org) => {
    setSelectedOrgForDetail(org);
    setDetailedViewMode('edit');
    fetchSelectedOrgUsers(org.id);
  };

  const handleBackToList = () => {
    setDetailedViewMode(null);
    setSelectedOrgForDetail(null);
    setSelectedOrgUsers([]);
  };

  const handleSaveChanges = async () => {
    console.log('=== SAVE CHANGES CLICKED IN ADMIN ===');
    console.log('Selected org for detail:', selectedOrgForDetail);
    console.log('Digital products to save:', selectedOrgForDetail.digitalProducts);
    
    if (!currentUser) {
      message.error('You must be logged in to save changes');
      return;
    }

    try {
      setLoading(true);
      const orgRef = doc(db, 'c3_organisations', selectedOrgForDetail.id);
      console.log('Updating org document with:', selectedOrgForDetail);
      
      // Update organization document
      const updateData = {
        ...selectedOrgForDetail,
        digitalProducts: selectedOrgForDetail.digitalProducts || [],
        customDigitalProducts: selectedOrgForDetail.customDigitalProducts || {},
        updatedAt: new Date(),
        updatedBy: currentUser.uid
      };
      
      console.log('Final update data:', updateData);
      await updateDoc(orgRef, updateData);
              console.log('Organisation document updated successfully');

      // Update product mappings
              console.log('Setting up organisation products...');
              await setupOrganisationProducts(
        db,
        selectedOrgForDetail.id,
        selectedOrgForDetail.subscriptionPlan,
        selectedOrgForDetail.digitalProducts || [],
        currentUser
      );
              console.log('Organisation products setup completed');
      
      message.success('Organisation updated successfully');
      loadOrganisations();
    } catch (err) {
      console.error('Error updating organisation:', err);
      message.error('Failed to update organisation');
    } finally {
      setLoading(false);
    }
  };



          // Filter organisations based on active status
  const filteredOrganisations = showActiveOnly 
    ? organisations.filter(org => org.clientStatus === 'active')
    : organisations;

  const columns = [
    {
      title: 'Organisation Name',
      dataIndex: 'name',
      key: 'name',
      render: (text) => text || 'Unnamed Organisation'
    },
    {
      title: 'Status',
      dataIndex: 'clientStatus',
      key: 'clientStatus',
      render: (status) => (
        <Tag color={status === 'active' ? 'green' : 'red'}>
          {status === 'active' ? 'Active' : 'Inactive'}
        </Tag>
      )
    },
    {
      title: 'Subscription Plan',
      dataIndex: 'subscriptionPlan',
      key: 'subscriptionPlan',
      render: (plan) => plan || 'Not Set'
    },
    {
      title: 'Industry',
      dataIndex: 'industry',
      key: 'industry',
      render: (industry) => industry || 'Not Set'
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => date ? new Date(date.toDate()).toLocaleDateString() : 'N/A'
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button 
            type="primary" 
            onClick={() => handleViewOrg(record)}
            style={{ backgroundColor: '#39325b', borderColor: '#39325b' }}
          >
            View
          </Button>
          <Button 
            onClick={() => handleEditOrgModal(record)}
            style={{ borderColor: '#39325b', color: '#39325b' }}
          >
            Edit
          </Button>
          {record.clientStatus === 'active' && (
            <Button 
              danger
              onClick={() => handleDeactivateClick(record)}
            >
              Deactivate
            </Button>
          )}
          {record.clientStatus === 'inactive' && (
            <Button 
              type="primary"
              onClick={() => handleReactivateClick(record)}
              style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
            >
              Reactivate
            </Button>
          )}
          {record.isTestOrganization && (currentUser?.role === 'super_admin' || currentUser?.isAdmin) && (
            <Button 
              danger
              type="dashed"
              onClick={() => handleDeleteTestOrgClick(record)}
              icon={<DeleteOutlined />}
              style={{ borderColor: '#ff4d4f', color: '#ff4d4f' }}
            >
              Delete Test Org
            </Button>
          )}
        </Space>
      )
    }
  ];

  const renderClientsContent = () => {
    if (detailedViewMode) {
      return (
        <div>
          <div className="flex justify-between items-center mb-4">
            <Title level={4}>
              {detailedViewMode === 'view' ? 'View' : 'Edit'} Organisation
            </Title>
            <Button onClick={handleBackToList}>Back to List</Button>
          </div>

          <Card>
            {detailedViewMode === 'edit' && (
              <div className="mb-4" style={{ textAlign: 'right', borderBottom: '1px solid #f0f0f0', paddingBottom: '12px' }}>
                <Space>
                  <Button 
                    onClick={handleBackToList}
                    style={{ marginRight: '8px' }}
                  >
                    Cancel
                  </Button>
                  <Button 
                    type="primary" 
                    onClick={() => handleSaveChanges()}
                    style={{ backgroundColor: '#39325b', borderColor: '#39325b' }}
                  >
                    Save Organization
                  </Button>
                  <Button 
                    danger
                    onClick={() => handleOpenDeepDelete(selectedOrgForDetail)}
                  >
                    Delete Organization (Deep)
                  </Button>
                </Space>
              </div>
            )}
            <Tabs defaultActiveKey="account" onChange={(key) => {
              // Auto-refresh Users tab on activation
              if (key === 'users') {
                console.log('🔁 Users tab activated - triggering auto refresh');
                setUsersTabRefreshTick(Date.now());
              }
            }}>
              <Tabs.TabPane 
                tab={
                  <Tooltip title="View and manage subscription details, financial information, and account management">
                    <strong>Account and Revenue</strong>
                  </Tooltip>
                } 
                key="account"
              >
                <div className="mb-4">
                  <h5>Subscription Details</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Subscription Plan:</label>
                        {detailedViewMode === 'edit' ? (
                          <Select
                            value={selectedOrgForDetail.subscriptionPlan}
                            onChange={value => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              subscriptionPlan: value
                            })}
                            style={{ width: '100%' }}
                            options={SUBSCRIPTION_PLANS}
                            placeholder="Select subscription plan"
                          />
                        ) : (
                          <div>{selectedOrgForDetail.subscriptionPlan || 'Not Set'}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label>Billing Status:</label>
                        {detailedViewMode === 'edit' ? (
                          <Select
                            value={selectedOrgForDetail.billingStatus}
                            onChange={value => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              billingStatus: value
                            })}
                            style={{ width: '100%' }}
                            options={[
                              { value: 'active', label: 'Active' },
                              { value: 'past_due', label: 'Past Due' },
                              { value: 'suspended', label: 'Suspended' },
                              { value: 'cancelled', label: 'Cancelled' }
                            ]}
                            placeholder="Select billing status"
                          />
                        ) : (
                          <div>{selectedOrgForDetail.billingStatus || 'Not Set'}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Last Payment Date:</label>
                        <div>{selectedOrgForDetail.lastPaymentDate ? new Date(selectedOrgForDetail.lastPaymentDate.toDate()).toLocaleDateString() : 'N/A'}</div>
                      </div>
                      <div className="mb-3">
                        <label>Next Payment Date:</label>
                        <div>{selectedOrgForDetail.nextPaymentDate ? new Date(selectedOrgForDetail.nextPaymentDate.toDate()).toLocaleDateString() : 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <h5>Financial Overview</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Annual Contract Value (ACV):</label>
                        {detailedViewMode === 'edit' ? (
                          <Input
                            type="number"
                            value={selectedOrgForDetail.annualContractValue}
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              annualContractValue: parseFloat(e.target.value)
                            })}
                            prefix="$"
                            placeholder="Enter ACV"
                          />
                        ) : (
                          <div>${selectedOrgForDetail.annualContractValue?.toLocaleString() || 'Not Set'}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label>Payment Frequency:</label>
                        {detailedViewMode === 'edit' ? (
                          <Select
                            value={selectedOrgForDetail.paymentFrequency}
                            onChange={value => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              paymentFrequency: value
                            })}
                            style={{ width: '100%' }}
                            options={[
                              { value: 'monthly', label: 'Monthly' },
                              { value: 'quarterly', label: 'Quarterly' },
                              { value: 'annually', label: 'Annually' }
                            ]}
                            placeholder="Select payment frequency"
                          />
                        ) : (
                          <div>{selectedOrgForDetail.paymentFrequency || 'Not Set'}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Contract Start Date:</label>
                        {detailedViewMode === 'edit' ? (
                          <Input
                            type="date"
                            value={selectedOrgForDetail.contractStartDate}
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              contractStartDate: e.target.value
                            })}
                          />
                        ) : (
                          <div>{selectedOrgForDetail.contractStartDate || 'Not Set'}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label>Contract End Date:</label>
                        {detailedViewMode === 'edit' ? (
                          <Input
                            type="date"
                            value={selectedOrgForDetail.contractEndDate}
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              contractEndDate: e.target.value
                            })}
                          />
                        ) : (
                          <div>{selectedOrgForDetail.contractEndDate || 'Not Set'}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <h5>Usage Metrics</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Organisation Users:</label>
                        <div>{selectedOrgUsers.length} users</div>
                      </div>
                      <div className="mb-3">
                        <label>Total Incidents:</label>
                        <div>{selectedOrgForDetail.totalIncidents || 0} incidents</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Last Incident Date:</label>
                        <div>{selectedOrgForDetail.lastIncidentDate ? new Date(selectedOrgForDetail.lastIncidentDate.toDate()).toLocaleDateString() : 'N/A'}</div>
                      </div>
                      <div className="mb-3">
                        <label>Platform Usage (Last 30 Days):</label>
                        <div>{selectedOrgForDetail.platformUsage || '0%'}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <h5>Account Management</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Account Manager:</label>
                        {detailedViewMode === 'edit' ? (
                          <Input
                            value={selectedOrgForDetail.accountManager}
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              accountManager: e.target.value
                            })}
                            placeholder="Enter account manager name"
                          />
                        ) : (
                          <div>{selectedOrgForDetail.accountManager || 'Not Assigned'}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label>Customer Success Manager:</label>
                        {detailedViewMode === 'edit' ? (
                          <Input
                            value={selectedOrgForDetail.customerSuccessManager}
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              customerSuccessManager: e.target.value
                            })}
                            placeholder="Enter CSM name"
                          />
                        ) : (
                          <div>{selectedOrgForDetail.customerSuccessManager || 'Not Assigned'}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Last Account Review:</label>
                        <div>{selectedOrgForDetail.lastAccountReview ? new Date(selectedOrgForDetail.lastAccountReview.toDate()).toLocaleDateString() : 'N/A'}</div>
                      </div>
                      <div className="mb-3">
                        <label>Next Account Review:</label>
                        <div>{selectedOrgForDetail.nextAccountReview ? new Date(selectedOrgForDetail.nextAccountReview.toDate()).toLocaleDateString() : 'N/A'}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <h5>Additional Services</h5>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label>Custom Features:</label>
                        {detailedViewMode === 'edit' ? (
                          <Select
                            mode="multiple"
                            value={selectedOrgForDetail.customFeatures || []}
                            onChange={value => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              customFeatures: value
                            })}
                            style={{ width: '100%' }}
                            options={[
                              { value: 'custom_branding', label: 'Custom Branding' },
                              { value: 'api_access', label: 'API Access' },
                              { value: 'dedicated_support', label: 'Dedicated Support' },
                              { value: 'custom_integrations', label: 'Custom Integrations' },
                              { value: 'advanced_analytics', label: 'Advanced Analytics' }
                            ]}
                            placeholder="Select custom features"
                          />
                        ) : (
                          <div>
                            {selectedOrgForDetail.customFeatures?.length > 0 
                              ? selectedOrgForDetail.customFeatures.join(', ') 
                              : 'No custom features'}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Tabs.TabPane>

              <Tabs.TabPane 
                tab={
                  <Tooltip title="View and edit basic organisation information, addresses, and timezone settings">
                    <strong>Basic Info</strong>
                  </Tooltip>
                } 
                key="basic"
              >
                <div className="mb-4">
                  <h5>Organisation Details</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Name:</label>
                        {detailedViewMode === 'edit' ? (
                          <Input 
                            value={selectedOrgForDetail.name} 
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              name: e.target.value
                            })}
                            placeholder="Enter organisation name"
                          />
                        ) : (
                          <div>{selectedOrgForDetail.name}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label>Industry:</label>
                        {detailedViewMode === 'edit' ? (
                          <Select
                            value={selectedOrgForDetail.industry}
                            onChange={value => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              industry: value
                            })}
                            style={{ width: '100%' }}
                            options={INDUSTRY_SECTORS.map(sector => ({ value: sector, label: sector }))}
                            placeholder="Select industry sector"
                          />
                        ) : (
                          <div>{selectedOrgForDetail.industry}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>ABN or Legal Entity:</label>
                        {detailedViewMode === 'edit' ? (
                          <Input
                            value={selectedOrgForDetail.abn}
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              abn: e.target.value
                            })}
                            placeholder="Enter ABN or legal entity"
                          />
                        ) : (
                          <div>{selectedOrgForDetail.abn || 'Not Set'}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <label>Description:</label>
                        {detailedViewMode === 'edit' ? (
                          <Input.TextArea 
                            value={selectedOrgForDetail.description} 
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              description: e.target.value
                            })}
                            placeholder="Enter organisation description"
                            rows={4}
                          />
                        ) : (
                          <div>{selectedOrgForDetail.description}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <h5>Business Addresses</h5>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label>Primary Business Address:</label>
                        {detailedViewMode === 'edit' ? (
                          <Input.TextArea 
                            value={selectedOrgForDetail.primaryAddress}
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              primaryAddress: e.target.value
                            })}
                            placeholder="Enter primary business address"
                            rows={3}
                          />
                        ) : (
                          <div>{selectedOrgForDetail.primaryAddress || 'Not Set'}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label>Additional Locations:</label>
                    {detailedViewMode === 'edit' ? (
                      <Form.List name="additionalLocations">
                        {(fields, { add, remove }) => (
                          <>
                            {fields.map(({ key, name, ...restField }) => (
                              <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                <Form.Item
                                  {...restField}
                                  name={[name, 'address']}
                                  rules={[{ required: true, message: 'Missing address' }]}
                                >
                                  <Input.TextArea 
                                    placeholder="Additional location address"
                                    rows={2}
                                    value={selectedOrgForDetail.additionalLocations?.[name]?.address}
                                    onChange={e => {
                                      const newLocations = [...(selectedOrgForDetail.additionalLocations || [])];
                                      newLocations[name] = { ...newLocations[name], address: e.target.value };
                                      setSelectedOrgForDetail({
                                        ...selectedOrgForDetail,
                                        additionalLocations: newLocations
                                      });
                                    }}
                                  />
                                </Form.Item>
                                <MinusCircleOutlined onClick={() => remove(name)} />
                              </Space>
                            ))}
                            <Form.Item>
                              <Button 
                                type="dashed" 
                                onClick={() => add()} 
                                block 
                                icon={<PlusOutlined />}
                              >
                                Add Location
                              </Button>
                            </Form.Item>
                          </>
                        )}
                      </Form.List>
                    ) : (
                      <div>
                        {selectedOrgForDetail.additionalLocations?.length > 0 ? (
                          selectedOrgForDetail.additionalLocations.map((location, index) => (
                            <div key={index} className="mb-2">
                              {location.address}
                            </div>
                          ))
                        ) : (
                          'No additional locations'
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="mb-4">
                  <h5>Timezone</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label>Organisation Timezone:</label>
                        {detailedViewMode === 'edit' ? (
                          <Select
                            value={selectedOrgForDetail.timezone}
                            onChange={value => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              timezone: value
                            })}
                            style={{ width: '100%' }}
                            options={TIMEZONES.map(tz => ({ value: tz, label: tz.replace('_', ' ') }))}
                            placeholder="Select timezone"
                          />
                        ) : (
                          <div>{selectedOrgForDetail.timezone || 'Not Set'}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Super Admin Only: Test Organization Management */}
                {(currentUser?.role === 'super_admin' || currentUser?.isAdmin) && detailedViewMode === 'edit' && (
                  <div className="mb-4" style={{ borderTop: '2px solid #ff4d4f', paddingTop: '16px', backgroundColor: '#fff2f0', padding: '16px', borderRadius: '6px' }}>
                    <h5 style={{ color: '#cf1322', marginBottom: '12px' }}>âš ï¸ Super Admin Controls</h5>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="mb-3">
                          <Checkbox
                            checked={selectedOrgForDetail.isTestOrganization || false}
                            onChange={e => setSelectedOrgForDetail({
                              ...selectedOrgForDetail,
                              isTestOrganization: e.target.checked
                            })}
                            style={{ fontSize: '14px' }}
                          >
                            <strong>Mark as Test Organization</strong>
                            <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '4px' }}>
                              âš ï¸ Enables permanent deletion. Only use for test/demo data that can be safely removed.
                            </div>
                          </Checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Tabs.TabPane>

              <Tabs.TabPane 
                tab={
                  <Tooltip title="Manage complete CMT structure and team member assignments">
                    <strong>CMT Management</strong>
                  </Tooltip>
                } 
                key="cmtmanagement"
              >
                <CMTAdminInterface 
                  organizationData={selectedOrgForDetail}
                  onClose={handleBackToList}
                />
              </Tabs.TabPane>

              {/* Sites and Staff Tab - Super Admin Only */}
              {currentUser?.isSuperAdmin && (
                <Tabs.TabPane 
                  tab={
                    <Tooltip title="Upload and manage organizational sites and staff data via CSV/Excel">
                      <strong>Sites and Staff</strong>
                    </Tooltip>
                  } 
                  key="sitesandstaff"
                >
                  <div style={{ padding: '16px 0' }}>
                    <Tabs type="card" defaultActiveKey="sites">
                      <Tabs.TabPane 
                        tab={
                          <span>
                            🏢 Site Upload
                          </span>
                        }
                        key="sites"
                      >
                        <SiteUpload 
                          orgId={selectedOrgForDetail?.id}
                          orgName={selectedOrgForDetail?.name}
                          onSitesUploaded={(results) => {
                            console.log('Sites uploaded for org:', selectedOrgForDetail?.id, results);
                            message.success(`Successfully uploaded ${results.successful} sites for ${selectedOrgForDetail?.name}`);
                          }}
                        />
                      </Tabs.TabPane>
                      
                      <Tabs.TabPane 
                        tab={
                          <span>
                            👥 Staff Upload
                          </span>
                        }
                        key="staff"
                      >
                        <StaffUpload 
                          orgId={selectedOrgForDetail?.id}
                          orgName={selectedOrgForDetail?.name}
                        />
                      </Tabs.TabPane>
                    </Tabs>
                  </div>
                </Tabs.TabPane>
              )}

              <Tabs.TabPane 
                tab={
                  <Tooltip title="View and manage regulatory notification rules, including triggers, deadlines, and notification methods">
                    <strong>Regulatory Rules</strong>
                  </Tooltip>
                } 
                key="regulatory"
              >
                <div className="mb-4">
                  <h5>Regulatory Notification Rules</h5>
                  <div className="row">
                    <div className="col-md-12">
                      {detailedViewMode === 'edit' ? (
                        <div>
                          {selectedOrgForDetail.regulatoryRules?.map((rule, index) => {
                            console.log(`Rendering rule ${index}:`, rule);
                            return (
                                <div key={index} style={{ marginBottom: 24, padding: 16, border: '1px solid #f0f0f0', borderRadius: 4 }}>
                                  <Space direction="vertical" style={{ width: '100%' }}>
                                    <Form.Item
                                      label="Trigger"
                                      rules={[{ required: true, message: 'Please enter trigger' }]}
                                      tooltip="What event triggers this notification (e.g., cyber breach, data loss)"
                                    >
                                      <Input 
                                        value={rule.trigger}
                                        onChange={e => {
                                          const newRules = [...selectedOrgForDetail.regulatoryRules];
                                          newRules[index] = { ...newRules[index], trigger: e.target.value };
                                          setSelectedOrgForDetail({
                                            ...selectedOrgForDetail,
                                            regulatoryRules: newRules
                                          });
                                        }}
                                      />
                                    </Form.Item>

                                    <Form.Item
                                      label="Deadline"
                                      tooltip={rule.immediateNotificationRequired ? "Deadline is not applicable for immediate notifications" : "Time to notify after trigger"}
                                      required={!rule.immediateNotificationRequired}
                                    >
                                      <Space.Compact style={{ width: '100%', display: 'flex' }}>
                                        <Form.Item
                                          rules={rule.immediateNotificationRequired ? [] : [{ required: true, message: 'Please enter deadline value' }]}
                                          style={{ flex: 2, marginBottom: 0 }}
                                        >
                                          <InputNumber
                                            min={1}
                                            placeholder={rule.immediateNotificationRequired ? "N/A - Immediate" : "Enter deadline value"}
                                            style={{ 
                                              width: '100%',
                                              backgroundColor: rule.immediateNotificationRequired ? '#f5f5f5' : 'white',
                                              color: rule.immediateNotificationRequired ? '#999' : 'inherit'
                                            }}
                                            value={rule.immediateNotificationRequired ? null : rule.deadlineValue}
                                            disabled={rule.immediateNotificationRequired}
                                            onChange={value => {
                                              if (!rule.immediateNotificationRequired) {
                                                const newRules = [...selectedOrgForDetail.regulatoryRules];
                                                newRules[index] = { ...newRules[index], deadlineValue: value };
                                                setSelectedOrgForDetail({
                                                  ...selectedOrgForDetail,
                                                  regulatoryRules: newRules
                                                });
                                              }
                                            }}
                                          />
                                        </Form.Item>
                                        <Form.Item
                                          style={{ flex: 1, marginBottom: 0 }}
                                        >
                                          <Select
                                            value={rule.immediateNotificationRequired ? 'immediate' : rule.deadlineUnit}
                                            disabled={rule.immediateNotificationRequired}
                                            style={{ 
                                              width: '100%',
                                              backgroundColor: rule.immediateNotificationRequired ? '#f5f5f5' : 'white'
                                            }}
                                            onChange={value => {
                                              if (!rule.immediateNotificationRequired) {
                                                const newRules = [...selectedOrgForDetail.regulatoryRules];
                                                newRules[index] = { ...newRules[index], deadlineUnit: value };
                                                setSelectedOrgForDetail({
                                                  ...selectedOrgForDetail,
                                                  regulatoryRules: newRules
                                                });
                                              }
                                            }}
                                            options={rule.immediateNotificationRequired ? 
                                              [{ label: 'Immediate', value: 'immediate' }] : 
                                              TIME_UNITS
                                            }
                                          />
                                        </Form.Item>
                                      </Space.Compact>
                                    </Form.Item>

                                    <Form.Item
                                      label="Immediate Notification"
                                      tooltip="Check this if immediate notification is required regardless of deadline"
                                      style={{ marginBottom: '16px' }}
                                    >
                                      <Checkbox
                                        checked={rule.immediateNotificationRequired || false}
                                        onChange={e => {
                                          console.log('Immediate notification checkbox changed:', e.target.checked);
                                          const newRules = [...selectedOrgForDetail.regulatoryRules];
                                          const updatedRule = { ...newRules[index] };
                                          
                                          if (e.target.checked) {
                                            // When immediate notification is enabled
                                            updatedRule.immediateNotificationRequired = true;
                                            // Store original values for potential restoration
                                            updatedRule._originalDeadlineValue = updatedRule.deadlineValue;
                                            updatedRule._originalDeadlineUnit = updatedRule.deadlineUnit;
                                            // Set special values for immediate notification
                                            updatedRule.deadlineValue = 0;
                                            updatedRule.deadlineUnit = 'immediate';
                                          } else {
                                            // When immediate notification is disabled
                                            updatedRule.immediateNotificationRequired = false;
                                            // Restore original values if they exist, otherwise use defaults
                                            updatedRule.deadlineValue = updatedRule._originalDeadlineValue || 24;
                                            updatedRule.deadlineUnit = updatedRule._originalDeadlineUnit || 'hours';
                                            // Clean up temporary storage
                                            delete updatedRule._originalDeadlineValue;
                                            delete updatedRule._originalDeadlineUnit;
                                          }
                                          
                                          newRules[index] = updatedRule;
                                          setSelectedOrgForDetail({
                                            ...selectedOrgForDetail,
                                            regulatoryRules: newRules
                                          });
                                        }}
                                        style={{ fontSize: '14px' }}
                                      >
                                        <span style={{ fontWeight: '500' }}>Immediate notification required</span>
                                      </Checkbox>
                                    </Form.Item>

                                    <Form.Item
                                      label="Regulator"
                                      rules={[{ required: true, message: 'Please select regulator' }]}
                                      tooltip="Who needs to be notified"
                                    >
                                      <Input 
                                        value={rule.regulator}
                                        onChange={e => {
                                          const newRules = [...selectedOrgForDetail.regulatoryRules];
                                          newRules[index] = { ...newRules[index], regulator: e.target.value };
                                          setSelectedOrgForDetail({
                                            ...selectedOrgForDetail,
                                            regulatoryRules: newRules
                                          });
                                        }}
                                      />
                                    </Form.Item>

                                    <Form.Item
                                      label="Method"
                                      rules={[{ required: true, message: 'Please select notification method(s)' }]}
                                      tooltip="How the notification should be delivered (can select multiple)"
                                    >
                                      <Select
                                        mode="multiple"
                                        value={Array.isArray(rule.method) ? rule.method : [rule.method]}
                                        onChange={value => {
                                          const newRules = [...selectedOrgForDetail.regulatoryRules];
                                          newRules[index] = { ...newRules[index], method: value };
                                          setSelectedOrgForDetail({
                                            ...selectedOrgForDetail,
                                            regulatoryRules: newRules
                                          });
                                        }}
                                        placeholder="Select notification methods"
                                      >
                                        {NOTIFICATION_METHODS.map(method => (
                                          <Select.Option key={method} value={method}>
                                            {method}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </Form.Item>

                                    <Form.Item
                                      label="Sender"
                                      rules={[{ required: true, message: 'Please enter sender' }]}
                                      tooltip="Who should send the notification (e.g., CISO, CEO)"
                                    >
                                      <Input 
                                        value={rule.sender}
                                        onChange={e => {
                                          const newRules = [...selectedOrgForDetail.regulatoryRules];
                                          newRules[index] = { ...newRules[index], sender: e.target.value };
                                          setSelectedOrgForDetail({
                                            ...selectedOrgForDetail,
                                            regulatoryRules: newRules
                                          });
                                        }}
                                      />
                                    </Form.Item>

                                    <Button 
                                      type="text" 
                                      danger 
                                      onClick={() => {
                                        Modal.confirm({
                                          title: 'Remove Regulatory Rule',
                                          icon: <ExclamationCircleOutlined />,
                                          content: (
                                            <div>
                                              <p>Are you sure you want to remove this regulatory rule?</p>
                                              <div style={{ 
                                                backgroundColor: '#f5f5f5', 
                                                padding: '12px', 
                                                borderRadius: '4px', 
                                                marginTop: '12px' 
                                              }}>
                                                <strong>Trigger:</strong> {rule.trigger || 'Not specified'}<br />
                                                <strong>Regulator:</strong> {rule.regulator || 'Not specified'}<br />
                                                <strong>Deadline:</strong> {rule.deadlineValue} {rule.deadlineUnit}
                                              </div>
                                              <p style={{ marginTop: '12px', color: '#ff4d4f' }}>
                                                <strong>Warning:</strong> This action cannot be undone and will affect all future incidents for this organization.
                                              </p>
                                            </div>
                                          ),
                                          okText: 'Yes, Remove Rule',
                                          okType: 'danger',
                                          cancelText: 'Cancel',
                                          onOk() {
                                            const newRules = [...selectedOrgForDetail.regulatoryRules];
                                            newRules.splice(index, 1);
                                            setSelectedOrgForDetail({
                                              ...selectedOrgForDetail,
                                              regulatoryRules: newRules
                                            });
                                            message.success('Regulatory rule removed successfully');
                                          },
                                          onCancel() {
                                            // Do nothing - user cancelled
                                          },
                                        });
                                      }} 
                                      icon={<MinusCircleOutlined />}
                                    >
                                      Remove Rule
                                    </Button>
                                  </Space>
                                </div>
                            );
                          })}

                              <div style={{ marginTop: '16px' }}>
                                <Button
                                  type="dashed"
                                  onClick={() => {
                                    const newRules = [...(selectedOrgForDetail.regulatoryRules || [])];
                                    newRules.push({
                                      trigger: '',
                                      deadlineValue: 24,
                                      deadlineUnit: 'hours',
                                      regulator: '',
                                      method: 'Email',
                                      sender: '',
                                      immediateNotificationRequired: false
                                    });
                                    setSelectedOrgForDetail({
                                      ...selectedOrgForDetail,
                                      regulatoryRules: newRules
                                    });
                                  }}
                                  block
                                  icon={<PlusOutlined />}
                                >
                                  Add Regulatory Rule
                                </Button>
                              </div>
                        </div>
                      ) : (
                        <div>
                          {selectedOrgForDetail.regulatoryRules?.length > 0 ? (
                            selectedOrgForDetail.regulatoryRules.map((rule, index) => (
                              <div key={index} style={{ marginBottom: 24, padding: 16, border: '1px solid #f0f0f0', borderRadius: 4 }}>
                                <div className="mb-2"><strong>Trigger:</strong> {rule.trigger}</div>
                                <div className="mb-2">
                                  <strong>Deadline:</strong> {rule.deadlineValue} {rule.deadlineUnit}
                                </div>
                                <div className="mb-2">
                                  <strong>Regulator:</strong> {rule.regulator}
                                </div>
                                <div className="mb-2"><strong>Method:</strong> {rule.method}</div>
                                <div className="mb-2"><strong>Sender:</strong> {rule.sender}</div>
                                {rule.immediateNotificationRequired && (
                                  <div className="mb-2">
                                    <strong>Immediate Notification:</strong> 
                                    <Tag color="red" style={{ marginLeft: '8px' }}>Required</Tag>
                                  </div>
                                )}
                              </div>
                            ))
                          ) : (
                            'No regulatory rules defined'
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Tabs.TabPane>

              <Tabs.TabPane 
                tab={
                  <Tooltip title="View and manage digital products, notification preferences, and templates">
                    <strong>Digital Products</strong>
                  </Tooltip>
                } 
                key="digital"
              >
                <div className="mb-4">
                  <h5>Digital Products</h5>
                  <div className="row">
                    <div className="col-md-12">
                      <Card 
                        title="Digital Products Configuration" 
                        className="mb-4"
                        extra={detailedViewMode === 'edit' ? (
                          <Button 
                            type="primary" 
                            icon={<PlusOutlined />}
                            size="small"
                            onClick={() => setAddDigitalProductModalVisible(true)}
                            style={{ backgroundColor: '#39325b', borderColor: '#39325b' }}
                          >
                            Add Custom Product
                          </Button>
                        ) : null}
                      >
                        {/* Header with organization info */}
                        <div style={{ marginBottom: '24px', padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '6px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                              <Text strong style={{ fontSize: '16px', color: '#1890ff' }}>
                                {selectedOrgForDetail.name}
                              </Text>
                              <div style={{ fontSize: '13px', color: '#666', marginTop: '4px' }}>
                                Subscription: <Tag color="blue">{selectedOrgForDetail.subscriptionPlan?.toUpperCase() || 'Not Set'}</Tag>
                              </div>
                            </div>
                            <div style={{ fontSize: '13px', color: '#666' }}>
                              {(selectedOrgForDetail.digitalProducts || []).length} of {Object.keys(DIGITAL_PRODUCTS).length} products enabled
                            </div>
                          </div>
                        </div>

                        {/* Single unified product list */}
                        <div style={{ marginBottom: '24px' }}>
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            marginBottom: '16px' 
                          }}>
                            <Text strong style={{ fontSize: '16px' }}>All Available Digital Products</Text>
                            {detailedViewMode === 'edit' && (
                              <Space>
                                <Button 
                                  size="small"
                                  onClick={() => {
                                    // Enable all products that are available for this plan
                                    const normalizedOrgPlan = selectedOrgForDetail.subscriptionPlan?.toUpperCase().replace('-', '_');
                                    const availableProducts = Object.entries(DIGITAL_PRODUCTS)
                                      .filter(([_, product]) => 
                                        !product.subscriptionTiers || 
                                        product.subscriptionTiers.includes(normalizedOrgPlan)
                                      )
                                      .map(([_, product]) => product.id);
                                    
                                    console.log(`🚀 Enable All Available clicked. Plan: ${selectedOrgForDetail.subscriptionPlan}, Available products:`, availableProducts);
                                    setSelectedOrgForDetail({
                                      ...selectedOrgForDetail,
                                      digitalProducts: availableProducts
                                    });
                                  }}
                                >
                                  Enable All Available
                                </Button>
                                <Button 
                                  size="small"
                                  onClick={() => {
                                    // Disable all products
                                    setSelectedOrgForDetail({
                                      ...selectedOrgForDetail,
                                      digitalProducts: []
                                    });
                                  }}
                                >
                                  Disable All
                                </Button>
                              </Space>
                            )}
                          </div>
                          
                          {/* Beautiful unified product list */}
                          <div style={{ border: '1px solid #e8e8e8', borderRadius: '8px', overflow: 'hidden' }}>
                            {Object.entries(DIGITAL_PRODUCTS).map(([key, product], index) => {
                              // 🚨 FIX: Check for both product.id AND key to handle different data formats
                              const productIdentifier = product.id || key;
                              const isEnabled = (selectedOrgForDetail.digitalProducts || []).includes(productIdentifier);
                              const isEven = index % 2 === 0;
                              // 🚨 FIX: Normalize subscription plan comparison (enterprise-pro vs ENTERPRISE_PRO)
                              const normalizedOrgPlan = selectedOrgForDetail.subscriptionPlan?.toUpperCase().replace('-', '_');
                              const isAvailableForPlan = !product.subscriptionTiers || 
                                product.subscriptionTiers.includes(normalizedOrgPlan);
                              
                              if (index === 0) {
                                console.log(`🔍 Digital Products Debug - Org Plan: ${selectedOrgForDetail.subscriptionPlan}, Normalized: ${normalizedOrgPlan}, Current products:`, selectedOrgForDetail.digitalProducts);
                                console.log(`🔍 First product ${product.name}: enabled=${isEnabled}, identifier=${productIdentifier}, availableForPlan=${isAvailableForPlan}`);
                                console.log(`🔍 DetailedViewMode: ${detailedViewMode}, Organization:`, selectedOrgForDetail.name);
                                console.log(`🔍 Product subscription tiers:`, product.subscriptionTiers);
                              }
                              
                              return (
                                <div 
                                  key={key}
                                  style={{
                                    backgroundColor: isEven ? '#fafafa' : '#ffffff',
                                    padding: '16px 20px',
                                    borderBottom: index < Object.keys(DIGITAL_PRODUCTS).length - 1 ? '1px solid #f0f0f0' : 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    opacity: !isAvailableForPlan ? 0.6 : 1,
                                    cursor: detailedViewMode === 'edit' && isAvailableForPlan ? 'pointer' : 'default',
                                    transition: 'all 0.2s ease'
                                  }}
                                  onMouseEnter={(e) => {
                                    if (detailedViewMode === 'edit' && isAvailableForPlan) {
                                      e.currentTarget.style.backgroundColor = isEven ? '#f0f0f0' : '#f5f5f5';
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = isEven ? '#fafafa' : '#ffffff';
                                  }}
                                  onClick={() => {
                                    console.log(`🎯 Row clicked for ${product.name}. Edit mode: ${detailedViewMode}, Available: ${isAvailableForPlan}`);
                                    if (detailedViewMode === 'edit' && isAvailableForPlan) {
                                      console.log(`🎯 Toggling product: ${product.name} (${productIdentifier})`);
                                      const currentProducts = selectedOrgForDetail.digitalProducts || [];
                                      const newProducts = isEnabled 
                                        ? currentProducts.filter(p => p !== productIdentifier)
                                        : [...currentProducts, productIdentifier];
                                      
                                      console.log(`📝 Row click updating products from:`, currentProducts, 'to:', newProducts);
                                      setSelectedOrgForDetail({
                                        ...selectedOrgForDetail,
                                        digitalProducts: newProducts
                                      });
                                    } else {
                                      console.log(`❌ Row click blocked: detailedViewMode=${detailedViewMode}, isAvailableForPlan=${isAvailableForPlan}`);
                                    }
                                  }}
                                >
                                  {/* Status indicator */}
                                  <div style={{ width: '60px', textAlign: 'center' }}>
                                    {detailedViewMode === 'edit' && isAvailableForPlan ? (
                                      <div 
                                        onClick={(e) => {
                                          e.stopPropagation(); // 🚨 NUCLEAR: Stop ALL event propagation
                                        }}
                                        onMouseDown={(e) => {
                                          e.stopPropagation(); // 🚨 Also stop mousedown
                                        }}
                                      >
                                        <Switch
                                          checked={isEnabled}
                                          size="small"
                                          onChange={(checked) => {
                                            console.log(`🎯 Switch toggled for ${product.name}: ${checked}`);
                                            console.log(`🔍 Switch debug - productIdentifier: ${productIdentifier}, current digitalProducts:`, selectedOrgForDetail.digitalProducts);
                                            const currentProducts = selectedOrgForDetail.digitalProducts || [];
                                            const newProducts = checked 
                                              ? [...currentProducts, productIdentifier]
                                              : currentProducts.filter(p => p !== productIdentifier);
                                            
                                            console.log(`📝 Switch updating products from:`, currentProducts, 'to:', newProducts);
                                            setSelectedOrgForDetail({
                                              ...selectedOrgForDetail,
                                              digitalProducts: newProducts
                                            });
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <div style={{
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        backgroundColor: isEnabled ? '#52c41a' : '#d9d9d9',
                                        margin: '0 auto'
                                      }} />
                                    )}
                                  </div>

                                  {/* Product info */}
                                  <div style={{ flex: 1, marginLeft: '16px' }}>
                                    <div style={{ 
                                      fontWeight: '600', 
                                      fontSize: '14px', 
                                      color: isEnabled ? '#1890ff' : '#262626',
                                      marginBottom: '4px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px'
                                    }}>
                                      {product.name}
                                      {!isAvailableForPlan && (
                                        <Tag size="small" color="orange">Upgrade Required</Tag>
                                      )}
                                    </div>
                                    <div style={{ 
                                      fontSize: '13px', 
                                      color: '#8c8c8c',
                                      lineHeight: '1.4',
                                      marginBottom: '6px'
                                    }}>
                                      {product.description}
                                    </div>
                                    <div style={{
                                      fontSize: '11px',
                                      color: '#bfbfbf',
                                      fontStyle: 'italic'
                                    }}>
                                      Available for: {product.subscriptionTiers?.join(', ') || 'All plans'}
                                    </div>
                                  </div>

                                  {/* Status label */}
                                  <div style={{ width: '80px', textAlign: 'right' }}>
                                    {isEnabled ? (
                                      <Tag color="success">Enabled</Tag>
                                    ) : isAvailableForPlan ? (
                                      <Tag color="default">Disabled</Tag>
                                    ) : (
                                      <Tag color="orange">Locked</Tag>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                          
                          {detailedViewMode === 'edit' && (
                            <div style={{ 
                              fontSize: '12px', 
                              color: '#888', 
                              fontStyle: 'italic', 
                              marginTop: '12px',
                              padding: '8px 12px',
                              backgroundColor: '#f6f8fa',
                              borderRadius: '4px'
                            }}>
                              💡 Toggle the switches above to enable/disable products. Locked products require a subscription upgrade.
                            </div>
                          )}
                        </div>
                      </Card>
                    </div>
                  </div>
                </div>
              </Tabs.TabPane>

              <Tabs.TabPane 
                tab={
                  <Tooltip title="Invite users, manage CMT assignments, and control user access">
                    <strong>Users</strong>
                  </Tooltip>
                } 
                key="users"
              >
                <EnhancedUsersTabV2 
                  selectedOrgId={selectedOrgForDetail?.id}
                  selectedOrgName={selectedOrgForDetail?.name}
                  selectedOrgData={selectedOrgForDetail}
                  refreshTick={usersTabRefreshTick}
                />
              </Tabs.TabPane>
            </Tabs>
          </Card>
        </div>
      );
    }

    // Main table view
    return (
      <div>
        <div className="flex justify-between items-center mb-4">
          <div>
            <Title level={4}>Client Organisations</Title>
            <Switch
              checked={showActiveOnly}
              onChange={setShowActiveOnly}
              checkedChildren="Active Only"
              unCheckedChildren="Show All"
            />
          </div>
        </div>
        
        <Table
          dataSource={filteredOrganisations}
          columns={columns}
          rowKey="id"
          loading={selectedOrgUsersLoading}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} organisations`,
          }}
        />
      </div>
    );
  };

  return (
    <div className="p-4">
      <PageHeader title="Admin and Settings" />

      <div className="card shadow-sm mb-4">
        <div className="card-body p-0">
          <ul className="nav nav-tabs nav-justified mb-4" style={{ borderBottom: '2px solid #39325b' }}>
            {/* Plan tab removed */}
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'onboard' ? 'active' : ''}`}
                style={{ color: activeTab === 'onboard' ? '#fff' : '#39325b', backgroundColor: activeTab === 'onboard' ? '#39325b' : '#fff', border: 'none', borderBottom: activeTab === 'onboard' ? '2px solid #39325b' : 'none', fontWeight: 500 }}
                onClick={() => setActiveTab('onboard')}
              >
                Onboard Client Organisation
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'clients' ? 'active' : ''}`}
                style={{ color: activeTab === 'clients' ? '#fff' : '#39325b', backgroundColor: activeTab === 'clients' ? '#39325b' : '#fff', border: 'none', borderBottom: activeTab === 'clients' ? '2px solid #39325b' : 'none', fontWeight: 500 }}
                onClick={() => setActiveTab('clients')}
              >
                Client Organisations
              </button>
            </li>
            {/* CMT Hierarchy tab removed */}
          </ul>

          <div className="card-body p-4">
            {/* Plan tab content removed */}

            {activeTab === 'onboard' && (
              <div>
                <h3>Client Organisation Onboarding</h3>
                <Button type="primary" onClick={handleStartOnboarding}>
                  Start New Organisation Onboarding
                </Button>
              </div>
            )}

            {activeTab === 'clients' && renderClientsContent()}

            {/* CMT Hierarchy content removed */}
          </div>
        </div>
      </div>

      {/* Modals */}
      <Modal
        title="Delete Organization (Deep)"
        open={isDeepDeleteModalVisible}
        onOk={handleConfirmDeepDelete}
        onCancel={handleCancelDeepDelete}
        okText="Delete"
        cancelText="Cancel"
        okButtonProps={{ danger: true, disabled: deepDeleteConfirmText !== deepDeleteTargetOrg?.name }}
      >
        <div style={{ display: 'grid', gap: 12 }}>
          <div>
            This will archive the organisation, remove all of its users, and delete Auth users who belong exclusively to this organisation.
          </div>
          <div>
            <Checkbox checked={deleteAuthExclusive} onChange={(e) => setDeleteAuthExclusive(e.target.checked)}>
              Also delete Auth users who belong only to this org
            </Checkbox>
          </div>
          <div>
            Type the organisation name to confirm: <strong>{deepDeleteTargetOrg?.name}</strong>
          </div>
          <Input value={deepDeleteConfirmText} onChange={(e) => setDeepDeleteConfirmText(e.target.value)} placeholder="Type org name exactly" />
        </div>
      </Modal>
      <Modal
        title={
          <Space>
            <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />
            <span>Deactivate Organisation</span>
          </Space>
        }
        open={isDeactivateModalVisible}
        onOk={handleDeactivateConfirm}
        onCancel={handleDeactivateCancel}
        okText="Deactivate"
        cancelText="Cancel"
        okButtonProps={{ 
          danger: true,
          disabled: deactivateConfirmText !== orgToDeactivate?.name
        }}
      >
        <p>Are you sure you want to deactivate "{orgToDeactivate?.name}"?</p>
        <p>Type the organization name to confirm:</p>
        <Input
          value={deactivateConfirmText}
          onChange={(e) => setDeactivateConfirmText(e.target.value)}
          placeholder={`Type "${orgToDeactivate?.name}" to confirm`}
        />
      </Modal>

      {/* Reactivate Organisation Modal */}
      <Modal
        title={
          <Space>
            <CheckCircleOutlined style={{ color: '#52c41a' }} />
            <span>Reactivate Organisation</span>
          </Space>
        }
        open={isReactivateModalVisible}
        onOk={handleReactivateConfirm}
        onCancel={handleReactivateCancel}
        okText="Reactivate"
        cancelText="Cancel"
        okButtonProps={{ 
          type: 'primary',
          style: { backgroundColor: '#52c41a', borderColor: '#52c41a' },
          disabled: reactivateConfirmText !== 'YES'
        }}
      >
        <p>Are you sure you want to reactivate "{orgToReactivate?.name}"?</p>
        <p>Type "YES" to confirm reactivation:</p>
        <Input
          value={reactivateConfirmText}
          onChange={(e) => setReactivateConfirmText(e.target.value)}
          placeholder="Type YES to confirm"
        />
      </Modal>

      {/* Test Organization Deletion Modal */}
      <Modal
        title={
          <Space>
            <DeleteOutlined style={{ color: '#ff4d4f' }} />
            <span>Permanently Delete Test Organization</span>
          </Space>
        }
        open={isDeleteTestOrgModalVisible}
        onOk={handleDeleteTestOrgConfirm}
        onCancel={handleDeleteTestOrgCancel}
        okText="Delete Permanently"
        cancelText="Cancel"
        okButtonProps={{ 
          danger: true,
          disabled: deleteConfirmText !== orgToDelete?.name
        }}
        width={600}
      >
        <div style={{ color: '#cf1322', marginBottom: '16px', padding: '12px', backgroundColor: '#fff2f0', borderRadius: '6px', border: '1px solid #ffccc7' }}>
          <strong>⚠️ WARNING: This action cannot be undone!</strong>
          <br />
          This will permanently delete the organization and all associated data.
        </div>
        
        <p>You are about to permanently delete the test organization:</p>
        <div style={{ backgroundColor: '#f5f5f5', padding: '12px', borderRadius: '4px', marginBottom: '16px' }}>
          <strong>Organization:</strong> {orgToDelete?.name}<br />
          <strong>Type:</strong> Test Organization<br />
          <strong>Created:</strong> {orgToDelete?.createdAt ? new Date(orgToDelete.createdAt.toDate()).toLocaleDateString() : 'Unknown'}
        </div>
        
        <p>This will delete:</p>
        <ul>
          <li>Organization data and settings</li>
          <li>All CMTs and team assignments</li>
          <li>All incidents and tasks</li>
          <li>All crisis plans and notifications</li>
          <li>Associated test user accounts</li>
        </ul>
        
        <p style={{ marginTop: '16px' }}>
          <strong>Type the organization name exactly to confirm deletion:</strong>
        </p>
        <Input
          value={deleteConfirmText}
          onChange={(e) => setDeleteConfirmText(e.target.value)}
          placeholder={`Type "${orgToDelete?.name}" to confirm`}
          style={{ marginTop: '8px' }}
        />
      </Modal>



      {/* Add Digital Product Modal */}
      <Modal
        title="Add Custom Digital Product"
        open={addDigitalProductModalVisible}
        onCancel={() => setAddDigitalProductModalVisible(false)}
        footer={null}
        width={500}
      >
        <Form
          layout="vertical"
          onFinish={(values) => {
            const customProductKey = `custom_${Date.now()}`;
            const updatedProducts = [...(selectedOrgForDetail.digitalProducts || []), customProductKey];
            
            // Also need to update the DIGITAL_PRODUCTS object to include this custom product
            // For now, we'll just add it to the organization's product list
            setSelectedOrgForDetail({
              ...selectedOrgForDetail,
              digitalProducts: updatedProducts,
              customDigitalProducts: {
                ...selectedOrgForDetail.customDigitalProducts,
                [customProductKey]: {
                  name: values.productName,
                  description: values.productDescription,
                  isCustom: true,
                  createdAt: new Date(),
                  createdBy: currentUser.uid
                }
              }
            });

            message.success('Custom digital product added successfully');
            setAddDigitalProductModalVisible(false);
          }}
        >
          <Form.Item 
            name="productName" 
            label="Product Name" 
            rules={[{ required: true, message: 'Please enter product name' }]}
          >
            <Input placeholder="Enter custom product name" />
          </Form.Item>
          
          <Form.Item 
            name="productDescription" 
            label="Product Description"
          >
            <Input.TextArea 
              placeholder="Enter product description" 
              rows={3}
            />
          </Form.Item>

          <div style={{ textAlign: 'right', marginTop: '20px' }}>
            <Space>
              <Button onClick={() => setAddDigitalProductModalVisible(false)}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" style={{ backgroundColor: '#39325b', borderColor: '#39325b' }}>
                Add Product
              </Button>
            </Space>
          </div>
        </Form>
      </Modal>
    </div>
  );
}
